import { View } from "react-native"
import { BFBackButton } from "@/components/standard/BFBackButton"
import { Vertical } from "@/components/standard/BFLayout"
import { Body, H5 } from "@/components/standard/BFText"
import { useSafeAreaInsets } from "react-native-safe-area-context"

export const BFScreenHeader = ({
  title,
  subTitle,
}: {
  title: string
  subTitle?: string
}) => {
  const insets = useSafeAreaInsets()
  return (
    <View
      className={
        "p-5 relative justify-center items-center border-border border-b min-h-8 bg-card"
      }
      style={{ paddingTop: insets.top + 20 }}
    >
      <Vertical>
        <H5 className={"text-center"}>{title}</H5>
        {subTitle && <Body className={"text-center"}>{subTitle}</Body>}
      </Vertical>
      <BFBackButton
        className={"absolute left-5 top-1/2 -translate-y-1/2"}
        dark={true}
      />
    </View>
  )
}
